// extracted by mini-css-extract-plugin
export default {"container":"style_container__3+oof","answers":"style_answers__7PzBW"};